import { ArgumentNullException } from '../../../../utility/exception/argument-null.exception';
import { PrimitiveValueObject } from '../../../../utility/model/primitive-value-object.model';

export class KnowledgeDocumentQuotationTargetId extends PrimitiveValueObject<string> {
  static create(value: string): KnowledgeDocumentQuotationTargetId {
    if (value === null) {
      return new KnowledgeDocumentQuotationTargetId('');
    }
    return new KnowledgeDocumentQuotationTargetId(value);
  }
}
